import { render, staticRenderFns } from "./OfferSwitchModal.vue?vue&type=template&id=36c87d13&"
import script from "./OfferSwitchModal.vue?vue&type=script&lang=js&"
export * from "./OfferSwitchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports